import React from "react";

const Stat_Descriptive_Stat = () => {
  return (
    <div>
      <h1>Stat Descriptive Stat</h1>
    </div>
  );
};

export default Stat_Descriptive_Stat;
